import { render, staticRenderFns } from "./ArchiveView.vue?vue&type=template&id=12609d92&"
import script from "./ArchiveView.vue?vue&type=script&lang=js&"
export * from "./ArchiveView.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports